/* QOALÉ V3 — één klein script, geen libraries.
   Kleurwissel (hele pagina), fotoslider, leeftijd → positie, popups, reviews-popup, winkelwagen (AJAX). */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = document.documentElement;
  const dataEl = $('#qoale-data');
  // Shopify's t-filter escapet HTML (baby's → baby&#39;s); wij zetten die teksten via textContent → één keer terugvertalen
  const unesc = (() => { const ta = document.createElement('textarea'); const f = v => typeof v === 'string' ? (/&[#a-z0-9]+;/i.test(v) ? ((ta.innerHTML = v), ta.value) : v) : Array.isArray(v) ? v.map(f) : v && typeof v === 'object' ? Object.fromEntries(Object.entries(v).map(([k, x]) => [k, f(x)])) : v; return f; })();
  const D = dataEl ? unesc(JSON.parse(dataEl.textContent)) : null;
  const T = D ? D.t : {};
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const state = { colour: D ? D.current : 0, months: +($('[data-months]')?.textContent || 3), pos: 'inward' };

  /* ---------- geld ---------- */
  function money(cents, fmt = (D && D.moneyFormat) || '€{{amount_with_comma_separator}}') {
    const n = (cents / 100).toFixed(2);
    const withSep = (num, th, dec) => { const [a, b] = num.split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? dec + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: withSep(n, ',', '.'), amount_no_decimals: withSep(Math.round(cents / 100) + '', ',', ''),
      amount_with_comma_separator: withSep(n, '.', ','), amount_no_decimals_with_comma_separator: withSep(Math.round(cents / 100) + '', '.', ''),
      amount_with_apostrophe_separator: withSep(n, "'", '.')
    }[k] ?? n));
  }

  /* ---------- kleur ---------- */
  const gal = $('[data-gal]'), galDots = $('[data-gal-dots]');
  const galIndex = () => gal ? Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)) : 0;
  const syncGal = () => { if (galDots && gal) galDots.textContent = `${galIndex() + 1} / ${gal.children.length}`; };
  gal && gal.addEventListener('scroll', () => requestAnimationFrame(syncGal), { passive: true });

  function setImg(el, src) {
    if (!el || !src || el.dataset.src === src) return;
    const first = !el.dataset.src; el.dataset.src = src;
    if (first) { el.src = src; return; }
    el.style.opacity = 0; setTimeout(() => { el.src = src; el.onload = () => (el.style.opacity = 1); }, 200);
  }

  function applyColour(i, opts = {}) {
    if (!D) return;
    const c = D.colours[i]; if (!c) return;
    state.colour = i;
    root.style.setProperty('--fabric', c.page); root.style.setProperty('--fabric-ink', c.ink); root.style.setProperty('--mute-k', c.muteK);
    $$('[data-i]').forEach(b => b.setAttribute('aria-checked', String(+b.dataset.i === i)));
    $$('[data-colour-name]').forEach(el => (el.textContent = c.name));
    const dot = $('.bar-dot'); if (dot && c.thumb) dot.style.backgroundImage = 'url("' + c.thumb + '")';
    $$('[data-price]').forEach(el => (el.textContent = c.price));
    $$('[data-klarna]').forEach(el => (el.textContent = c.klarna));
    $$('[data-mood]').forEach(el => (el.textContent = c.mood));
    $$('[data-fabric]').forEach(el => (el.textContent = c.fab));
    const input = $('[data-variant-input]'); if (input) input.value = c.variantId;
    $$('[data-add]').forEach(b => { b.disabled = !c.available; const l = $('[data-add-label]', b); if (l) l.textContent = c.available ? T.add : T.soldOut; });
    $$('[data-slot]').forEach(img => setImg(img, c.slots[img.dataset.slot]));
    if (!opts.initial && gal) {
      gal.style.opacity = 0;
      setTimeout(() => {
        gal.innerHTML = c.media.map((u, n) => `<img src="${u}" alt="${c.name}" ${n ? 'loading="lazy"' : ''} width="1000" height="1000">`).join('');
        gal.scrollLeft = 0; syncGal(); gal.style.opacity = 1;
      }, 180);
      if (c.variantId) { const u = new URL(location.href); u.searchParams.set('variant', c.variantId); history.replaceState(null, '', u); }
    }
    renderAge();
  }

  /* ---------- leeftijd → positie ---------- */
  const posFor = m => (m < 6 ? 'inward' : m < 12 ? 'front' : 'back');
  function renderAge() {
    if (!D || !$('[data-months]')) return;
    const c = D.colours[state.colour], p = posFor(state.months), t = T.pos[p];
    state.pos = p;
    $('[data-months]').textContent = state.months;
    $('[data-months-label]').textContent = state.months === 1 ? T.month : T.months;
    $('[data-adv-title]').textContent = t[1]; $('[data-adv-body]').textContent = t[2]; $('[data-adv-alt]').textContent = t[3];
    $('[data-m="-1"]').disabled = state.months <= 0; $('[data-m="1"]').disabled = state.months >= 36;
    const src = p === 'front' ? c.slots.front : p === 'back' ? c.slots.back_carry : null;
    setImg($('[data-stage-img]'), src || c.slots.inward);
    $('[data-chip]').textContent = `${(src || p === 'inward') ? t[0] : T.pos.inward[0]} · ${c.name}`;
  }

  /* ---------- popups ---------- */
  const sheet = $('[data-sheet-el]'), sheetBody = $('[data-sheet-body]');
  let carTrack = null;
  function openSheet(id, step = 0) {
    const tpl = document.getElementById('sheet-' + id); if (!tpl || !sheet) return;
    sheetBody.replaceChildren(tpl.content.cloneNode(true));
    if (D) {
      const c = D.colours[state.colour];
      $$('[data-klarna]', sheetBody).forEach(el => (el.textContent = c.klarna));
      $$('[data-colour-name]', sheetBody).forEach(el => (el.textContent = c.name));
      $$('[data-fabric]', sheetBody).forEach(el => (el.textContent = c.fab));
    }
    const car = $('[data-car]', sheetBody); if (car) initCar(car, step);
    const rv = $('[data-rv-list]', sheetBody); if (rv) renderReviews(rv);
    sheet.showModal();
    // showModal focust iets in de (nog onder het scherm geschoven) kaart → browser scrollt de dialog mee
    // en dat vecht met de schuifanimatie (doorschieten + terugveren). Scroll terugzetten, focus zonder scroll.
    sheet.scrollTop = 0; document.activeElement?.blur?.(); sheet.focus({ preventScroll: true });
    requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.add('in')));
  }
  function closeSheet() { if (!sheet || !sheet.open) return; sheet.classList.remove('in'); setTimeout(() => sheet.close(), 300); }
  sheet && sheet.addEventListener('click', e => { if (e.target === sheet) closeSheet(); });
  sheet && sheet.addEventListener('cancel', e => { e.preventDefault(); closeSheet(); });

  function initCar(car, start) {
    carTrack = $('[data-car-track]', car);
    carTrack.innerHTML = T.steps.map((s, i) => `<div class="car-slide"><img src="${T.stepImgs[i]}" alt="${T.step} ${i + 1}: ${s[0]}" width="600" height="900"><div><b>${i + 1}. ${s[0]}</b><p>${s[1]}</p></div></div>`).join('');
    const dots = $('[data-car-dots]', car); dots.innerHTML = T.steps.map(() => '<span></span>').join('');
    const sync = () => { const i = carIndex(); [...dots.children].forEach((d, j) => d.classList.toggle('on', j === i)); };
    carTrack.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    requestAnimationFrame(() => { carTrack.style.scrollBehavior = 'auto'; carTrack.scrollLeft = start * carTrack.clientWidth; carTrack.style.scrollBehavior = ''; sync(); });
  }
  const carIndex = () => Math.round(carTrack.scrollLeft / carTrack.clientWidth);
  const carGo = d => { if (!carTrack) return; const i = Math.max(0, Math.min(T.steps.length - 1, carIndex() + d)); carTrack.scrollTo({ left: i * carTrack.clientWidth }); };

  let reviewsCache = null;
  async function renderReviews(list) {
    try { reviewsCache = reviewsCache || await (await fetch(D.reviewsUrl)).json(); } catch { return; }
    const lang = D.lang, fmt = new Intl.DateTimeFormat(lang, { month: 'long', year: 'numeric' });
    list.replaceChildren(...reviewsCache.map(r => {
      const el = document.createElement('article'); el.className = 'rv-item';
      const own = r.src === lang, translated = !own && r.t[lang];
      const h = document.createElement('header'); h.innerHTML = '<b></b><span></span>';
      h.querySelector('b').textContent = r.name; h.querySelector('span').textContent = '★★★★★'.slice(0, r.rating);
      const p = document.createElement('p'); p.textContent = own ? r.body : (r.t[lang] || r.body);
      const meta = document.createElement('div'); meta.className = 'rv-meta'; meta.textContent = fmt.format(new Date(r.date + '-01'));
      if (r.verified) { const v = document.createElement('span'); v.className = 'rv-ok'; v.textContent = '✓ ' + T.verified; meta.append(v); }
      if (translated && T.from[r.src]) { const s = document.createElement('span'); s.textContent = T.from[r.src]; meta.append(s); }
      el.append(h, p);
      if (r.pic) { const im = new Image(); im.src = r.pic.replace(/width=\d+/, 'width=440'); im.alt = ''; im.loading = 'lazy'; el.append(im); }
      el.append(meta); return el;
    }));
  }

  /* ---------- winkelwagen ---------- */
  const drawer = $('.drawer');
  function openCart(on) { document.body.classList.toggle('cart-open', on); drawer && drawer.setAttribute('aria-hidden', String(!on)); }
  async function renderCart(cart) {
    cart = cart || await (await fetch(ROOT + 'cart.js')).json();
    $$('[data-cart-count]').forEach(el => (el.textContent = cart.item_count));
    const lines = $('[data-cart-lines]'); if (!lines) return;
    $('[data-cart-filled]').hidden = !cart.item_count;
    if (!cart.item_count) { lines.innerHTML = `<p class="cart-empty">${T.cartEmpty || ''}</p>`; return; }
    lines.innerHTML = '';
    cart.items.forEach(it => {
      const row = document.createElement('div'); row.className = 'line-item';
      row.innerHTML = `<img alt="" width="88" height="88"><div><b></b><br><span class="fine"></span><div class="cart-qty"><button type="button" data-qty="-1" aria-label="-">−</button><span></span><button type="button" data-qty="1" aria-label="+">+</button></div></div><b></b>`;
      if (it.image) row.querySelector('img').src = it.image + (it.image.includes('?') ? '&' : '?') + 'width=200';
      row.querySelector('div b').textContent = it.product_title;
      row.querySelector('.fine').textContent = it.variant_title || '';
      row.querySelector('.cart-qty span').textContent = it.quantity;
      row.lastElementChild.textContent = money(it.final_line_price);
      row.querySelectorAll('[data-qty]').forEach(b => (b.onclick = () => changeQty(it.key, it.quantity + +b.dataset.qty)));
      lines.append(row);
    });
    $('[data-cart-total]').textContent = money(cart.total_price);
    $('[data-cart-klarna]').textContent = money(Math.floor(cart.total_price / 3));
  }
  async function changeQty(key, quantity) {
    const r = await fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    renderCart(await r.json());
  }
  async function addCurrent(btn) {
    if (!D) return;
    const c = D.colours[state.colour]; if (!c.available || !c.variantId) return;
    const err = $('[data-cart-error]'); err && (err.hidden = true);
    const label = btn && ($('[data-add-label]', btn) || btn); const old = label && label.textContent;
    if (btn) { btn.disabled = true; if (label) label.textContent = T.adding; }
    try {
      const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: c.variantId, quantity: 1 }] }) });
      if (!r.ok) throw new Error((await r.json()).description || 'add failed');
      await renderCart(); openCart(true);
    } catch (e) { if (err) { err.textContent = T.error; err.hidden = false; } openCart(true); }
    finally { if (btn) { btn.disabled = false; if (label) label.textContent = old; } }
  }
  const form = $('[data-buy-form]');
  form && form.addEventListener('submit', e => { e.preventDefault(); addCurrent(form.querySelector('[data-add]')); });

  /* ---------- klikken ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('button, [data-close-cart], a[href^="#"]'); if (!t) return;
    if (t.tagName === 'A') { const id = HASH[t.getAttribute('href')]; if (id && document.getElementById('sheet-' + id)) { e.preventDefault(); openSheet(id); } return; }
    if (t.dataset.sheet) { openSheet(t.dataset.sheet, +(t.dataset.step || 0)); return; }
    if ('closeSheet' in t.dataset) { closeSheet(); return; }
    if (t.dataset.carGo) { carGo(+t.dataset.carGo); return; }
    if (t.dataset.galGo && gal) { const n = gal.children.length; gal.scrollTo({ left: ((galIndex() + +t.dataset.galGo + n) % n) * gal.clientWidth, behavior: 'smooth' }); return; }
    if (t.dataset.i !== undefined) { applyColour(+t.dataset.i); return; }
    if (t.dataset.m) { state.months = Math.max(0, Math.min(36, state.months + +t.dataset.m)); renderAge(); return; }
    if (t.dataset.cmp) {
      $$('[data-cmp]', sheetBody).forEach(b => b.setAttribute('aria-pressed', String(b === t)));
      $('.cmp-svg', sheetBody).dataset.state = t.dataset.cmp;
      const txt = $('[data-cmp-txt]', sheetBody); txt.textContent = txt.dataset[t.dataset.cmp];
      return;
    }
    if ('addCurrent' in t.dataset) { addCurrent(t); return; }
    if ('openCart' in t.dataset) { renderCart(); openCart(true); return; }
    if ('closeCart' in t.dataset) { openCart(false); return; }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') openCart(false); });

  /* ---------- koopbalk ---------- */
  const bar = $('[data-bar]');
  if (bar) {
    // zichtbaar zolang er geen koopknop in beeld is, ook bij binnenkomst: op mobiel staat de knop onder het eerste
    // scherm (eigenaar 2026-11-04). "In beeld" = minstens 3/4 van de knop zichtbaar (een randje telt niet).
    // Bij elke scroll/resize gemeten, ook bij een sprong naar boven (iPhone-statusbalk).
    const ctas = $$('main .cta');
    const inView = el => { const r = el.getBoundingClientRect(); return r.height > 0 && Math.min(r.bottom, innerHeight) - Math.max(r.top, 0) >= r.height * .75; };
    const upd = () => bar.classList.toggle('show', ctas.length > 0 && !ctas.some(inView));
    let tick = false;
    const later = () => { if (!tick) { tick = true; requestAnimationFrame(() => { tick = false; upd(); }); } };
    addEventListener('scroll', later, { passive: true }); addEventListener('resize', later); upd();
  }

  /* ---------- actieregel: datum nog eens in de browser (gecachte pagina); vooraf zien met ?promo=preview ---------- */
  $$('[data-promo]').forEach(el => {
    const d = new Date(), today = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    if ((today >= el.dataset.start && today <= el.dataset.end) || /[?&]promo=preview\b/.test(location.search)) el.hidden = false;
    else if (today > el.dataset.end) el.hidden = true;
  });

  /* ---------- start ---------- */
  if (D) { applyColour(state.colour, { initial: true }); syncGal(); }
  // oude pagina's (redirects) landen op een anker → bijbehorende popup openen
  const HASH = { '#shipping': 'shipping', '#how-to-wear': 'steps', '#trial': 'trial', '#safety': 'safety', '#details': 'details', '#returns-info': 'returns', '#contact': 'contact' };
  if (HASH[location.hash]) setTimeout(() => openSheet(HASH[location.hash]), 400);
  else if (/[?&]contact_posted=/.test(location.search) && document.getElementById('sheet-contact') && !document.querySelector('main .cform')) setTimeout(() => openSheet('contact'), 400);
})();
